import { render } from "./NodeFormComponent.vue?vue&type=template&id=7a36e966&scoped=true"
import script from "./NodeFormComponent.vue?vue&type=script&lang=js"
export * from "./NodeFormComponent.vue?vue&type=script&lang=js"

import "./NodeFormComponent.vue?vue&type=style&index=0&id=7a36e966&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a36e966"]])

export default __exports__